module.exports = __webpack_public_path__ + "img/file-heart-02.7dc12a48.svg";